import React, { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit, MdConfirmationNumber } from "react-icons/md";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";

import api from "../../../services/api";
import { Container, Cards, Card, Table, Title, ViewInput } from "./styles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  DatePicker,
  Switch,
  Spin,
  Pagination,
  Tooltip,
} from "antd";
import IntlCurrencyInput from "react-intl-currency-input";
import { addDays, format } from "date-fns";
import dayjs, { locale } from "dayjs";
import Loading from "../../../components/Loading";
import { getValue } from "../../../services/functions";
import { Message } from "../../../GlobalStyles";

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const { confirm } = Modal;

const Coupon = () => {
  const [coupons, setCoupons] = useState([]);
  const [couponsTotal, setCouponsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [minValue, setMinValue] = useState("");
  const [usageLimit, setUsageLimit] = useState("");
  const [isSingleUse, setIsSingleUse] = useState(false);
  const [active, setActive] = useState(true);
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [id, setId] = useState("");
  const [expirationDate, setExpirationDate] = useState(addDays(new Date(), 30));
  const [isOpen, setIsOpen] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  useEffect(() => {
    loadCoupons();
    window.scrollTo(0, 0);
  }, [page, filterSearch]);

  async function loadCoupons() {
    setIsLoading(true);
    await api
      .get(`/coupons?page=${page}${filter ? `&filter=${filter}` : ""}`)
      .then((response) => {
        setCoupons(response.data.coupons);
        setCouponsTotal(response.data.couponsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createCoupon() {
    setIsLoadingModal(true);
    if (!name || !value || !type) {
      toast.warning("Preencha os campos obrigatórios");
      setError(true);
    } else {
      await api
        .post(`/coupon`, {
          name: name,
          code: code,
          value: value,
          type: type,
          minValue: minValue,
          active: active,
          usageLimit: usageLimit,
          expirationDate: expirationDate,
          isSingleUse: isSingleUse,
        })
        .then((response) => {
          toast.success("Cupom de Desconto criado com sucesso");
          setIsOpen(false);
          loadCoupons();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function editCoupon() {
    setIsLoadingModal(true);
    if (!id || !name || !value || !type) {
      toast.warning("Preencha os campos obrigatórios");
      setError(true);
    } else {
      await api
        .put(`/coupon/${id}`, {
          name: name,
          code: code,
          value: value,
          type: type,
          minValue: minValue,
          active: active,
          usageLimit: usageLimit,
          expirationDate: expirationDate,
          isSingleUse: isSingleUse,
        })
        .then((response) => {
          toast.success("Cupom de Desconto editado com sucesso");
          setIsOpen(false);
          loadCoupons();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function deleteCoupon(coupon) {
    await api
      .delete(`/coupon/${coupon.id}`)
      .then((response) => {
        toast.success("Cupom de Desconto deletado com sucesso");
        loadCoupons();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Cupons de Desconto</h1>
      {isLoading ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: 100 }}
        >
          <Spin size="large" color="#008037" />
        </div>
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp separator="." duration={1} end={couponsTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  } else {
                    loadCoupons(0, filterSearch);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  if (page) {
                    setPage(0);
                  }
                  setFilter("");
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                marginBottom: 5,
              }}
              onClick={() => {
                setId("");
                setCode("");
                setName("");
                setUsageLimit("");
                setValue("");
                setType("");
                setMinValue("");
                setActive(true);
                setIsSingleUse(false);
                setExpirationDate(addDays(new Date(), 30));
                setError(false);
                setIsOpen(true);
              }}
            >
              Novo Cupom
            </Button>
          </div>
          {coupons.length ? (
            <div className="coupons-list">
              {coupons.map((coupon) => (
                <div className="coupon-card" key={coupon.id}>
                  <div className="main-info">
                    <Tooltip title={coupon.name}>
                      <strong>{coupon.name}</strong>
                    </Tooltip>
                    <span>{coupon.code.toUpperCase()}</span>
                  </div>

                  <div className="info-item">
                    <label>Status</label>
                    <div
                      className={`status-badge ${coupon.active ? "active" : "inactive"}`}
                    >
                      {coupon.active ? "Ativo" : "Inativo"}
                    </div>
                  </div>

                  <div className="info-item">
                    <label>Uso Único</label>
                    <div
                      className={`status-badge ${coupon.isSingleUse ? "single-use" : ""}`}
                      style={
                        !coupon.isSingleUse
                          ? {
                              background: "#eee",
                              color: "#666",
                              border: "1px solid #ddd",
                            }
                          : {}
                      }
                    >
                      {coupon.isSingleUse ? "Sim" : "Não"}
                    </div>
                  </div>

                  <div className="info-item">
                    <label>Valor Mínimo</label>
                    <span>{getValue(coupon.minValue)}</span>
                  </div>

                  <div className="info-item">
                    <label>Desconto</label>
                    <span style={{ color: "#008037", fontWeight: "bold" }}>
                      {coupon.type === "FIXED"
                        ? getValue(coupon.value)
                        : `${coupon.value}%`}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Limite Uso</label>
                    <span>{coupon.usageLimit || "Ilimitado"}</span>
                  </div>

                  <div className="info-item">
                    <label>Expira em</label>
                    <span>
                      {coupon.expirationDate
                        ? format(new Date(coupon.expirationDate), "dd/MM/yyyy")
                        : "Não expira"}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Editar">
                      <Button
                        shape="circle"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={<MdEdit size={18} />}
                        onClick={() => {
                          setId(coupon.id);
                          setName(coupon.name);
                          setCode(coupon.code);
                          setValue(coupon.value);
                          setType(coupon.type);
                          setActive(coupon.active);
                          setIsSingleUse(coupon.isSingleUse);
                          setUsageLimit(coupon.usageLimit);
                          setMinValue(coupon.minValue);
                          setExpirationDate(coupon.expirationDate);
                          setError(false);
                          setIsOpen(true);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <Button
                        shape="circle"
                        danger
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={<MdDelete size={18} />}
                        onClick={() => {
                          confirm({
                            okText: "Confirmar",
                            title: "Deseja excluir o Cupom de Desconto?",
                            icon: <ExclamationCircleFilled />,
                            content: `Após essa ação, o cupom ${coupon.name} será excluído.`,
                            onOk() {
                              deleteCoupon(coupon);
                            },
                            onCancel() {},
                            cancelText: "Cancelar",
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                  <Pagination
                    style={{
                      margin: "25px 0",
                      alignSelf: "center",
                    }}
                    defaultCurrent={page + 1}
                    pageSize={30}
                    onChange={(page) => {
                      setPage(page - 1);
                    }}
                    total={couponsTotal}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <MdConfirmationNumber
                size={50}
                color="#ccc"
                style={{ marginBottom: 15 }}
              />
              <Message>Nenhum cupom encontrado.</Message>
            </div>
          )}
        </>
      )}

      <Modal
        title="Cupom de Desconto"
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "EDITAR CUPOM" : "CADASTRAR CUPOM"}
        cancelText="FECHAR"
        onOk={() => {
          if (id) {
            editCoupon();
          } else {
            createCoupon();
          }
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 25,
          }}
        >
          <ViewInput>
            <p>Nome*</p>
            <Input
              status={error && !name && "error"}
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Código*</p>
            <Input
              status={error && !code && "error"}
              placeholder="codigo"
              value={code}
              onChange={(event) => setCode(event.target.value)}
            />
          </ViewInput>

          <ViewInput>
            <p>Desconto Fixo ou Percentual?*</p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                style={{
                  width: "49%",
                  borderColor: error && !type ? "#ff4d4f" : "",
                }}
                type={type == "FIXED" && "primary"}
                onClick={() => {
                  setType("FIXED");
                  setValue("");
                }}
              >
                Fixo
              </Button>
              <Button
                style={{
                  width: "49%",
                  borderColor: error && !type ? "#ff4d4f" : "",
                }}
                type={type == "PERCENTAGE" && "primary"}
                onClick={() => {
                  setType("PERCENTAGE");
                  setValue("");
                }}
              >
                Percentual
              </Button>
            </div>
          </ViewInput>
          {type == "PERCENTAGE" ? (
            <ViewInput>
              <p>Desconto em Percentual*</p>
              <Input
                status={error && !value && "error"}
                placeholder="desconto em percentual"
                value={value || ""}
                onChange={(event) =>
                  setValue(parseInt(event.target.value.replace(/[^0-9]/g, "")))
                }
              />
            </ViewInput>
          ) : (
            <ViewInput>
              <p>Valor de Desconto*</p>
              <IntlCurrencyInput
                style={{
                  width: "100%",
                  backgroundColor: "#FFF",
                  borderWidth: 0,
                  height: 32,
                  color: "#001B22",
                  padding: "4px 12px",
                  fontSize: 14,
                  borderWidth: 1,
                  borderColor: error && !value ? "#ff4d4f" : "#ccc",
                  borderStyle: "solid",
                  borderRadius: 2,
                  fontWeight: "400",
                  paddingLeft: 12,
                }}
                currency="BRL"
                config={currencyConfig}
                value={value || ""}
                onChange={(event, value) => setValue(value)}
              />
            </ViewInput>
          )}
          <ViewInput>
            <p>Limite de Uso*</p>
            <Input
              placeholder="quantas vezes pode usar"
              value={usageLimit || ""}
              onChange={(event) =>
                setUsageLimit(
                  parseInt(event.target.value.replace(/[^0-9]/g, "")),
                )
              }
            />
          </ViewInput>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Ativo?*</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={active}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setActive(!active);
                  }}
                />
              </div>
            </ViewInput>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Uso Unico?*</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={isSingleUse}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setIsSingleUse(!isSingleUse);
                  }}
                />
              </div>
            </ViewInput>
          </div>
          <ViewInput>
            <p>Valor Minimo*</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                height: 32,
                color: "#001B22",
                padding: "4px 12px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={minValue}
              onChange={(event, value) => setMinValue(value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Data de expiração</p>
            <DatePicker
              placeholder={"data de expiração"}
              format={"DD/MM/YYYY"}
              locale={locale}
              minDate={dayjs(addDays(new Date(), 1))}
              value={expirationDate ? dayjs(expirationDate) : ""}
              style={{
                minWidth: "100%",
                height: 32,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
              }}
              onChange={(date) => setExpirationDate(date)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
};

export default Coupon;
